import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isPlainObject, isString } from 'lodash';
import { TAccessState } from '../types';
import { ApiRequestSucceed } from '../saga/api/actions';
import { ILocalStorageData } from '../saga/localStorage/actions';

const COLLECTION_WHITELIST: Record<string, RegExp[]> = {
  access: [/^me$/, /^jwt$/, /^roles$/],
};

const accessSlice = createSlice({
  name: 'access',
  initialState: {
    me: undefined,
    jwt: undefined,
    roles: {},
  } as TAccessState,
  reducers: {
    setToken: (state, { payload }: PayloadAction<string | null>) => {
      state.jwt = !!payload ? payload : undefined;
    },
    setMe: (state, { payload }: PayloadAction<string | undefined>) => {
      state.me = payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase('localStorage/loaded' as const, (state, action) => {
        const { payload } = action as PayloadAction<ILocalStorageData>;
        if (payload.jwt) {
          state.jwt = payload.jwt;
        }
      })
      .addCase(ApiRequestSucceed, (state, { payload }) => {
        if (!isPlainObject(payload.data)) return;

        const data = payload.data as Record<string, Record<string, unknown>>;
        const newAccess = data.access;
        if (!newAccess) return;

        const patterns = COLLECTION_WHITELIST.access;
        const filtered = Object.fromEntries(
          Object.entries(newAccess).filter(([key]) => patterns.some(re => re.test(key)))
        );

        Object.assign(state, filtered);

        if (isString(newAccess.jwt)) {
          if (newAccess.jwt) {
            localStorage.setItem('jwt', newAccess.jwt);
          } else {
            localStorage.removeItem('jwt');
          }
        }
      });
  },
});

export const { setToken, setMe } = accessSlice.actions;
export default accessSlice.reducer;
